import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      radius: ['tile', 'tile-icon', 'panel'],
      shadow: [
        'elevation-1',
        'elevation-2',
        'elevation-3',
        'tile',
        'tile-hover',
        'ring-strong',
        'ring-selected',
        'dot-hollow',
        'dot-vacant',
        'sidebar-edge',
        'sidebar-toggle',
      ],
      text: ['xs-plus', 'sm-tight'],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const stopPropagation = (e: React.MouseEvent) => {
  e.preventDefault();
  e.stopPropagation();
};

export const scrollToTop = () => window.scrollTo(0, 0);

const MAX_DISPLAYED_COUNT = 99;

export const formatBadgeCount = (count: number): string =>
  count > MAX_DISPLAYED_COUNT ? `${MAX_DISPLAYED_COUNT}+` : `${count}`;
